import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addOfferStatus } from "../../../store/actions"
import { useEffect } from "react"

const AddOfferStatus = props => {
  const dispatch = useDispatch()
  document.title = "Add offer status"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      offer_status: "",
    },
    validationSchema: Yup.object({
      offer_status: Yup.string().required("Please Enter Offer Status"),
    }),
    onSubmit: values => {
      dispatch(addOfferStatus(values, props.history))
    },
  })

  const offerS = useSelector(state => state.offerStatus)
  const { error } = useSelector(state => ({
    error: state.offerStatus.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Offer Status" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formOfferStatus"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="offerStatus">
                            Offer Status
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="offer_status"
                            className={
                              validation.touched.offer_status &&
                              validation.errors.offer_status
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="offerStatus"
                            placeholder="Enter Material Standard"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.offer_status || ""}
                          />
                          {validation.touched.offer_status &&
                          validation.errors.offer_status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.offer_status}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {offerS && offerS.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddOfferStatus
